import React, { Component } from 'react';
import { useParams } from 'react-router-dom';
import { urlMap } from '../utils';
import '../assets/styles/AuthorSubscribeWidget.css';

function slugToDisplayName(slug) {
  return String(slug || 'this author')
    .split('-')
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
}

class AuthorSubscribeWidgetInner extends Component {
  state = {
    email: '',
    status: 'idle', // 'idle' | 'submitting' | 'success' | 'error'
    errorMsg: '',
  };

  getSafeSlug = () => String(this.props.authorSlug || '').trim().toLowerCase();

  handleSubscribe = async () => {
    const email = this.state.email.trim();
    if (!email) return;

    this.setState({ status: 'submitting', errorMsg: '' });
    try {
      const res = await fetch(urlMap.subscribeAuthorList(this.getSafeSlug()), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      if (!res.ok) throw new Error('failed');
      this.setState({ status: 'success', email: '' });
    } catch {
      this.setState({ status: 'error', errorMsg: 'Something went wrong. Please try again.' });
    }
  };

  handleKeyDown = (e) => {
    if (e.key === 'Enter') this.handleSubscribe();
  };

  render() {
    const { authorSlug } = this.props;
    const { email, status, errorMsg } = this.state;
    const authorName = slugToDisplayName(authorSlug);
    const isSubmitting = status === 'submitting';
    const isSuccess = status === 'success';

    return (
      <div className="asw">
        <div className="asw__row">
          <span className="asw__label">Follow {authorName}</span>
          <input
            type="email"
            className="asw__input"
            placeholder="your@email.com"
            value={email}
            onChange={(e) => this.setState({ email: e.target.value, status: 'idle', errorMsg: '' })}
            onKeyDown={this.handleKeyDown}
            disabled={isSubmitting || isSuccess}
            aria-label="Email address"
          />
          <button
            type="button"
            className="asw__btn"
            onClick={this.handleSubscribe}
            disabled={isSubmitting || isSuccess}
          >
            {isSubmitting ? 'Subscribing…' : 'Subscribe'}
          </button>
        </div>

        {status === 'success' && (
          <p className="asw__status asw__status--success" role="status">
            ✓ You're subscribed! You'll hear from {authorName} directly.
          </p>
        )}
        {status === 'error' && (
          <p className="asw__status asw__status--error" role="alert">
            ⚠ {errorMsg}
          </p>
        )}
      </div>
    );
  }
}

export default function AuthorSubscribeWidget() {
  const { authorSlug } = useParams();
  return <AuthorSubscribeWidgetInner authorSlug={authorSlug} />;
}
